export const defaultFetcherOptions = {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
};
